import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LOCALES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "orb-locale";

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return "en";
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return saved && translations[saved] ? saved : "en";
    } catch (e) {
      return "en";
    }
  });

  const meta = LOCALES.find((l) => l.locale === locale) || LOCALES[0];
  const dir = meta.dir;

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch (e) {
      /* localStorage unavailable (private mode) — ignore */
    }
    document.documentElement.lang = locale;
    document.documentElement.dir = dir;
  }, [locale, dir]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      dir,
      code: meta.code,
      t: translations[locale],
      locales: LOCALES,
    }),
    [locale, dir, meta.code]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
